import axios from 'axios';
import env from 'react-dotenv';
import {
    requestHandler,
    successHandler,
    errorHandler
} from 'network/interceptors';





let baseURL ='https://api.instagyfts.com/'; 





export const axiosInstance = axios.create({
    baseURL,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
});

// Handle request process
axiosInstance.interceptors.request.use((request) => requestHandler(request));
// Handle response process
axiosInstance.interceptors.response.use(
    (response) => successHandler(response),
    (error) => errorHandler(error)
);
